import React, { Component } from 'react';

class ContainerMid extends Component {
    constructor(props){
        super(props);
        this.state = {
            collMid: [
                {
                    id: 1,
                    subtitle: 'Chapter 3',
                    title: 'Foundations of Adaptive Systems and Information Theory',
                    text: 'This chapter introduces the fundamentals of adaptive systems: time series analysis, similarity measures, mean squared error, and persistence of excitation. It also explores the potential of information as a key tool in designing adaptive controllers.'
                },
                {
                    id: 2,
                    subtitle: 'Chapter 4',
                    title: 'Identification of Discrete Dynamic Systems',
                    text: 'Analytical and practical methods are presented for identifying systems of different orders, from the transfer function domain to state-space representations. Techniques include Sine Sweep, online learning, and the use of neural networks for system modeling.'
                }
            ]
            
        }
    }
    render() {
        return (
            <div className="chapter-list border-right-0">
                 {
                    this.state.collMid.map((data,i) => (
                        <div className="chapter-item" key={i}>
                            <h4><span>{data.subtitle} </span> {data.title}</h4>
                            <p>{data.text} </p>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default ContainerMid;
